<template>
  <v-card class="pa-4">
    <v-dialog v-model="transferFunds" max-width="600">
      <v-card>
        <v-card-title>Transfer Funds to {{ user.username }}</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="number"
              label="Amount"
              v-model="amountTransfer"
            />
            <v-btn
              :disabled="amountTransfer === '' || amountTransfer <= 0"
              color="primary"
              :loading="isLoadingTransferFunds"
              @click="transferToUser"
              >Transfer
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="creditWalletDialog" max-width="600">
      <v-card>
        <v-card-title>Credit {{ user.username }}</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="number"
              filled
              label="Amount"
              v-model="credit.amountTransfer"
            />
            <v-textarea
              label="Reason"
              filled
              v-model="credit.reason"
            ></v-textarea>
            <v-btn
              :disabled="!credit.amountTransfer || credit.amountTransfer <= 0"
              color="primary"
              :loading="isCreditLoading"
              @click="creditToUser"
              >Credit
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deactivateReason" max-width="600">
      <v-card>
        <v-card-title>Reason for Deactivating Account</v-card-title>
        <v-card-actions>
          <v-container>
            <v-textarea
              label="Reason"
              filled
              v-model="deactivitate.suspensionReason"
            ></v-textarea>
            <v-btn
              :disabled="!deactivitate.suspensionReason"
              color="primary"
              :loading="changingAccountStatus"
              @click="deactivateAccount"
              >Deactivate
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addPointsDialog" max-width="600">
      <v-card>
        <v-card-title>Add Cashback points {{ user.username }}</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="number"
              filled
              label="Amount"
              v-model="points.amount"
            />
            <!-- <v-textarea
              label="Reason"
              filled
              v-model="credit.reason"
            ></v-textarea> -->
            <v-btn
              :disabled="!points.amount || points.amount <= 0"
              color="primary"
              :loading="isCreditingPoints"
              @click="creditPoints"
              >Credit Points
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removePointsDialog" max-width="600">
      <v-card>
        <v-card-title>Remove Cashback points {{ user.username }}</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="number"
              filled
              label="Amount"
              v-model="points.amount"
            />
            <!-- <v-textarea
              label="Reason"
              filled
              v-model="credit.reason"
            ></v-textarea> -->
            <v-btn
              :disabled="!points.amount || points.amount <= 0"
              color="primary"
              :loading="isDebitingPoints"
              @click="debitPoints"
              >Deduct Points
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="debitWalletDialog" max-width="600">
      <v-card>
        <v-card-title>Debit {{ user.username }}</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="number"
              filled
              label="Amount"
              v-model="debit.amountTransfer"
            />
            <v-textarea
              label="Reason"
              filled
              v-model="debit.reason"
            ></v-textarea>
            <v-btn
              :disabled="!debit.amountTransfer || debit.amountTransfer <= 0"
              color="primary"
              :loading="isDebitLoading"
              @click="debitToUser"
              >Debit
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="changeEmailAddressDialog" max-width="600">
      <v-card>
        <v-card-title>Change Email Address {{ user.username }}</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="email"
              filled
              label="Email"
              v-model="emailAddress"
            />
            <v-btn
              :disabled="!emailAddress"
              color="primary"
              :loading="isChangingEmailAddress"
              @click="changeEmailAddress"
              >Change Email Address
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="accountStatementDialog" max-width="600">
      <v-card>
        <v-card-title> Generate Account Statement</v-card-title>
        <v-card-actions>
          <v-container>
            <v-text-field
              type="date"
              filled
              label="From"
              v-model="account.startDate"
            />
            <v-text-field
              type="date"
              filled
              label="To"
              v-model="account.endDate"
            />
            <v-btn
              color="primary"
              :loading="isGeneratingStatement"
              @click="generateAccountStatement"
              >Generate
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title>
      <span>User Details</span>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-progress-circular
              v-if="changingAccountStatus || isCreditingPoints"
              indeterminate
            ></v-progress-circular>
            <v-icon v-else>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            ripple
            @click="activateAccount"
            v-if="arrangeUserData.activeStatus === 'deactivated'"
            :loading="changingAccountStatus"
          >
            <v-list-item-content>
              <v-list-item-title> Active Account</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            ripple
            v-if="checkIfPermission('CREDIT_CASHBACK', admin.permissions)"
            @click="addPointsDialog = true"
            :loading="isCreditingPoints"
          >
            <v-list-item-content>
              <v-list-item-title> Add Cashback Points</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            ripple
            v-if="checkIfPermission('DEBIT_CASHBACK', admin.permissions)"
            @click="removePointsDialog = true"
            :loading="isDebitingPoints"
          >
            <v-list-item-content>
              <v-list-item-title> Remove Cashback Points</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            ripple
            v-if="checkIfPermission('fund user', admin.permissions)"
            @click="creditWalletDialog = true"
            :loading="changingAccountStatus"
          >
            <v-list-item-content>
              <v-list-item-title> Credit Wallet</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            ripple
            v-if="checkIfPermission('fund user', admin.permissions)"
            @click="debitWalletDialog = true"
          >
            <v-list-item-content>
              <v-list-item-title> Debit Wallet</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item ripple @click="accountStatementDialog = true">
            <v-list-item-content>
              <v-list-item-title> Account Statement</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item ripple @click="changeEmailAddressDialog = true">
            <v-list-item-content>
              <v-list-item-title> Change Email Address</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-item
            ripple
            @click="deactivateReason = true"
            v-if="arrangeUserData.activeStatus === 'active'"
            :loading="changingAccountStatus"
          >
            <v-list-item-content>
              <v-list-item-title> Deactivate/Suspend Account</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <div class=""></div>
    <v-overlay v-if="loadingUserData" opacity="0.8">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <p class="mb-0 font-weight-medium grey--text">Successful Purchase</p>
          <span class="text-h5"
            >{{ numberWithCommas(totalApprovedPurchase) }}
            <span class="grey--text subtitle-2">{{ userCurrency }}</span></span
          >
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p class="mb-0 font-weight-medium grey--text">Successful Sales</p>
          <span class="text-h5"
            >{{ numberWithCommas(totalApprovedSales) }}
            <span class="grey--text subtitle-2">{{ userCurrency }}</span></span
          >
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p class="mb-0 font-weight-medium grey--text">
            Successful Giftcard Sales
          </p>
          <span class="text-h5"
            >{{ numberWithCommas(totalApprovedGiftcard) }}
            <span class="grey--text subtitle-2">{{ userCurrency }}</span></span
          >
        </v-col>
        <!-- <v-col cols="12" sm="6" md="4">
            <p class="mb-0 font-weight-medium grey--text">Balance in Wallet</p>
            <span class="text-h5"
              >{{ arrangeUserData.balance }}
              <span class="grey--text subtitle-2">NGN</span></span
            >
          </v-col> -->
        <v-col cols="12" sm="6" md="4">
          <p class="mb-0 font-weight-medium grey--text">User Status</p>
          <span
            :class="`${
              isUserActive ? 'success--text' : 'error--text'
            } font-weight-bold text-capitalize mt-2 `"
            >{{ isUserActive ? 'Active' : 'Deactivated' }}</span
          >
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p class="mb-0 font-weight-medium grey--text">Registered Date</p>
          <span class="font-weight-medium overline"
            >{{ new Date(arrangeUserData.createdAt).toDateString() }}
          </span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p class="mb-2 font-weight-medium grey--text">Verification Status</p>
          <div class="d-flex">
            <span
              :class="`font-weight-medium mx-1 rounded-lg white--text px-3 py-2 ${
                arrangeUserData.email_verify ? 'success' : 'error'
              }`"
            >
              Email
            </span>
            <span
              :class="`font-weight-medium mx-1 rounded-lg white--text px-3 py-2 ${
                arrangeUserData.bvnVerified ? 'success' : 'error'
              }`"
            >
              BVN
            </span>
            <span
              :class="`font-weight-medium mx-1 rounded-lg white--text px-3 py-2 ${
                arrangeUserData.kycverify ? 'success' : 'error'
              }`"
              >KYC
            </span>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mb-2 mt-4"></v-divider>
      <p class="overline grey--text">User Info</p>
      <v-row v-for="info in arrangeUserData.info" :key="info.title">
        <v-col cols="5" md="5">
          <span class="grey--text text--darken-1">{{ info.title }}</span>
        </v-col>
        <v-col cols="7" md="7">
          <span class="grey--text text--darken-3 font-weight-medium">{{
            info.text
          }}</span>
        </v-col>
      </v-row>
      <!-- <v-divider class="mb-2 mt-4"></v-divider> -->
      <!-- <p class="overline grey--text">More information</p> -->
      <v-row v-for="info in arrangeUserData.moreInfo" :key="info.title">
        <v-col cols="5" md="5">
          <span class="grey--text text--darken-1">{{ info.title }}</span>
        </v-col>
        <v-col cols="7" md="7">
          <span class="grey--text text--darken-3 font-weight-medium">{{
            info.text
          }}</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <p class="overline grey--text">Transaction information</p>
    <v-tabs v-model="tabs">
      <v-tab> Sales</v-tab>
      <v-tab> Purchase</v-tab>
      <v-tab> Giftcard</v-tab>
      <v-tab> Referrals</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <!-- Sales -->
      <v-tab-item>
        <v-data-table
          :loading="loading"
          :items="transactionSales"
          :headers="headersForTransaction"
        >
          <template v-slot:[`item.rate`]="{ item }">
            <span>{{ item.rate.price }}</span>
            <span class="overline"> {{ item.rate.currency }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item.amount.price }}</span>
            <span class="overline"> {{ item.amount.currency }}</span>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <span>{{ item.price }}</span>
            <span class="overline"> {{ item.currencyCode }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-card
              :color="
                item.status == 'approved'
                  ? 'success'
                  : item.status == 'pending'
                  ? 'warning'
                  : 'error'
              "
              flat
              rounded="md"
              outlined
              class="text-capitalize text-center white--text pa-1"
            >
              {{ item.status }}
            </v-card>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Purchase -->
      <v-tab-item>
        <v-data-table
          :loading="loading"
          :items="transactionPurchase"
          :headers="headersForTransaction"
        >
          <template v-slot:[`item.rate`]="{ item }">
            <span>{{ item.rate.price }}</span>
            <span class="overline"> {{ item.rate.currency }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item.amount.price }}</span>
            <span class="overline"> {{ item.amount.currency }}</span>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <span>{{ item.price }}</span>
            <span class="overline"> {{ item.currencyCode }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-card
              :color="
                item.status == 'approved'
                  ? 'success'
                  : item.status == 'pending'
                  ? 'warning'
                  : 'error'
              "
              flat
              rounded="md"
              outlined
              class="text-capitalize text-center white--text pa-1"
            >
              {{ item.status }}
            </v-card>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Giftcard -->
      <v-tab-item>
        <v-data-table
          :loading="loading"
          :items="transactionGiftcard"
          :headers="headersForGiftcard"
        >
          <template v-slot:[`item.image`]="{ item }">
            <v-img :src="item.image" width="45"></v-img>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item.amount }}</span>
            <span class="overline"> {{ item.currencyCode }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-card
              :color="
                item.status == 'approved'
                  ? 'success'
                  : item.status == 'pending'
                  ? 'warning'
                  : 'error'
              "
              flat
              rounded="md"
              outlined
              class="text-capitalize text-center white--text pa-1"
            >
              {{ item.status }}
            </v-card>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Giftcard -->

      <v-tab-item>
        <v-card flat class="mt-5">
          <v-row>
            <v-card-title>User's Referral</v-card-title>
            <v-spacer />
            <v-select
              :items="[
                {
                  text: 'All',
                  value: 'all'
                },
                {
                  text: 'Active',
                  value: 'active-referrals'
                },
                {
                  text: 'Inactive',
                  value: 'inactive-referrals'
                }
              ]"
              label="Referral Status"
              v-model="referralStatus"
            ></v-select>
          </v-row>
          <v-data-table
            :loading="loadingReferrals"
            :headers="headers"
            :items="filteredReferrals"
          >
            <template v-slot:[`item.created`]="{ item }">
              <span>{{ new Date(item.createdAt).toDateString() }}</span>
            </template>
            <template v-slot:[`item.hasTransactionHistory`]="{ item }">
              <span
                :class="`text-capitalize rounded py-2 px-3 white--text ${
                  statusInfo(item.hasTransactionHistory).color
                }`"
                >{{ statusInfo(item.hasTransactionHistory).text }}</span
              >
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                :class="`text-capitalize rounded py-2 px-3 white--text ${
                  statusInfo(item.status).color
                }`"
                >{{ statusInfo(item.status).text }}</span
              >
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="accent" @click="$router.go(-1)">Back</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'
import { BASEURL } from '../../../api/const'
import Store from '../../../store'
import { numberWithCommas } from '../../../utils/helpers'
import userApi from '../../../api/admin/userManagement'
import transfer from '../../../api/admin/transfer'
import { mapState } from 'vuex'
import { getCurrencyCode } from '../../../utils/countryHelpers'
import rank from '../../../api/admin/rank'

export default {
  name: 'UserDetails',
  props: {
    open: Boolean
  },
  created() {
    this.userId = this.$route.params.id
    this.getUserDetails()
  },
  watch: {
    user(newValue, oldValue) {
      this.transactionPurchase = []
      this.transactionSales = []
      this.transactionGiftcard = []
      this.totalApprovedPurchase = 0
      this.totalApprovedSales = 0
      this.totalApprovedGiftcard = 0
      this.getTransactionForAUser(newValue._id || newValue.id)
    },
    removePointsDialog(newValue, oldValue) {
      if (newValue) {
        this.points = {}
      }
    },
    referralStatus(newValue, oldValue) {
      if (newValue) {
        this.getReferredUsersStatus()
      }
    }
  },
  data: () => ({
    numberWithCommas,
    deactivateReason: false,
    deactivitate: {
      suspensionReason: ''
    },
    isDeactivating: false,
    addPointsDialog: false,
    removePointsDialog: false,
    creditWalletDialog: false,
    accountStatementDialog: false,
    debitWalletDialog: false,
    isCreditLoading: false,
    isCreditingPoints: false,
    isDebitingPoints: false,
    isDebitLoading: false,
    isGeneratingStatement: false,
    loadingUserData: false,
    userId: '',
    credit: {},
    points: {},
    debit: {},
    data: {},
    user: {},
    account: {
      startDate: '',
      endDate: ''
    },
    tabs: null,
    userTransactions: [],
    loading: false,
    amountTransfer: '',
    transferFunds: false,
    isLoadingTransferFunds: false,
    referrals: [],
    loadingReferrals: false,
    ranks: [],
    loadingRanks: false,
    headers: [
      {
        text: 'Username',
        value: 'username',
        align: 'start'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Date Joined',
        value: 'created'
      },
      {
        text: 'Status (Account)',
        value: 'status'
      },
      {
        text: 'Status (Transactions)',
        value: 'hasTransactionHistory'
      }
    ],
    headersForTransaction: [
      {
        text: 'Trx ID.',
        align: 'start',
        sortable: false,
        value: 'trx'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Currency',
        value: 'currency'
      },
      {
        text: 'Amount',
        value: 'amount'
      },

      {
        text: 'Rate',
        value: 'rate'
      },
      {
        text: 'Price',
        value: 'price'
      },
      {
        text: 'Status',
        value: 'status'
      }
    ],
    headersForGiftcard: [
      {
        text: 'Trx ID',
        value: 'trx',
        sortable: false
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Giftcard',
        value: 'image'
      },
      {
        text: 'Name',
        value: 'giftcard.name'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Status',
        value: 'status'
      }
    ],
    transactionPurchase: [],
    transactionSales: [],
    transactionGiftcard: [],
    totalApprovedPurchase: 0,
    totalApprovedSales: 0,
    totalApprovedGiftcard: 0,
    changingAccountStatus: false,
    referralStatus: 'all',
    changeEmailAddressDialog: false,
    emailAddress: '',
    isChangingEmailAddress: false
  }),
  methods: {
    async changeEmailAddress() {
      this.isChangingEmailAddress = true
      const req = await userApi.users().update({
        userId: this.userId,
        email: this.emailAddress
      })
      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.isChangingEmailAddress = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Email Address Changed Successfully',
        status: true,
        error: false
      })
      this.isChangingEmailAddress = false
      this.changeEmailAddressDialog = false
    },
    async generateAccountStatement() {
      this.isGeneratingStatement = true

      const params = {}
      if (this.account.startDate) {
        if (new Date(this.account.startDate) > new Date()) {
          this.$store.dispatch('alert', {
            message: 'Start date cannot be greater than today',
            error: true,
            status: true
          })
          return
        }
        params.startDate = this.account.startDate
      }

      if (this.account.endDate) {
        if (new Date(this.account.endDate) > new Date()) {
          this.$store.dispatch('alert', {
            message: 'End date cannot be greater than today',
            error: true,
            status: true
          })
          return
        }
        params.endDate = this.account.endDate
      }

      const req = await userApi.users().generateAccountStatement({
        userId: this.userId,
        params
      })
      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.isGeneratingStatement = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Statement of Account Generated Succcessfully',
        status: true,
        error: false
      })
      window.open(req.data.data.link, '_blank')
      this.isGeneratingStatement = false
      this.accountStatementDialog = false
    },

    async creditToUser() {
      this.isCreditLoading = true
      const req = await transfer.data().creditUser({
        amount: this.credit.amountTransfer,
        userId: this.userId,
        reason: this.credit.reason
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        // this.transferFunds = false
        this.isCreditLoading = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Credit Successful',
        status: true,
        error: false
      })
      this.isCreditLoading = false
      this.creditWalletDialog = false
    },

    async creditPoints() {
      this.isCreditingPoints = true
      const req = await transfer.data().creditCashbackPoints({
        amount: this.points.amount,
        userId: this.userId
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.isCreditingPoints = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Credit Points Successful',
        status: true,
        error: false
      })

      this.isCreditingPoints = false
      this.addPointsDialog = false
    },
    async debitPoints() {
      this.isCreditingPoints = true
      const req = await transfer.data().debitCashbackPoints({
        amount: this.points.amount,
        userId: this.userId
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.isCreditingPoints = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Credit Points Successful',
        status: true,
        error: false
      })

      this.isDebitingPoints = false
      this.removePointsDialog = false
    },

    async debitToUser() {
      this.isDebitLoading = true
      const req = await transfer.data().debitUser({
        amount: this.debit.amountTransfer,
        userId: this.userId,
        reason: this.debit.reason
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        // this.transferFunds = false
        this.isDebitLoading = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Debit Successful',
        status: true,
        error: false
      })
      this.isDebitLoading = false
      this.debitWalletDialog = false
    },
    async getUserDetails() {
      this.loadingUserData = true
      const res = await userApi.users().getSingle({ userId: this.userId })
      this.user = res.data.data
      this.loadingUserData = false

      this.getRanks()
      this.referrals = this.user.referrals
    },
    async getTransactionForAUser() {
      this.loading = true

      const res = await axios.get(
        `${BASEURL}/transactions?user=${this.arrangeUserData._id}&populate=currency&populate=giftcard&limit=0`,
        {
          headers: {
            ...Store.getters['admin/getRequestHeaders'].headers,
            'x-auth-token': localStorage.getItem('deviceId')
          }
        }
      )
      this.userTransactions = res.data.data.data
      // Purchase
      this.transactionPurchase = res.data.data.data
        .filter((transaction) => transaction.type === 'purchase')
        .map((transaction) => ({
          ...transaction,
          id: transaction._id,
          transactionID: transaction._id,
          date: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toDateString(),
          currency: transaction.currency
            ? transaction.currency !== null
              ? transaction.currency.name
              : ''
            : '',
          trx: transaction.trx,
          amount: {
            price: numberWithCommas(transaction.amount),
            currency: 'USD'
          },
          rate: { price: transaction.rate, currency: transaction.currencyCode },
          price: transaction.main_amo,
          status: transaction.status
        }))

      this.transactionPurchase.forEach((e) => {
        if (e.status === 'approved') {
          this.totalApprovedPurchase = this.totalApprovedPurchase + e.price
        }
      })

      // Sales
      this.transactionSales = res.data.data.data
        .filter(
          (transaction) =>
            transaction.type === 'sale' && transaction.category !== 'giftcard'
        )
        .map((transaction) => ({
          ...transaction,
          id: transaction._id,
          transactionID: transaction._id,
          date: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toDateString(),
          amount: {
            price: numberWithCommas(transaction.amount),
            currency: 'USD'
          },
          currency: transaction.currency
            ? transaction.currency !== null
              ? transaction.currency.name
              : ''
            : '',
          trx: transaction.trx,
          rate: { price: transaction.rate, currency: transaction.currencyCode },
          price: transaction.main_amo,
          status: transaction.status
        }))

      this.transactionSales.forEach((e) => {
        if (e.status === 'approved') {
          this.totalApprovedSales = this.totalApprovedSales + e.price
        }
      })

      this.transactionGiftcard = res.data.data.data
        .filter((t) => t.category === 'giftcard')
        .map((trx) => ({
          ...trx,
          date: new Date(
            trx.created_at ? trx.created_at : trx.createdAt
          ).toDateString(),
          id: trx._id,
          image: trx.giftcard ? trx.giftcard.image : '',
          amount: trx.main_amo
        }))

      this.transactionGiftcard.forEach((e) => {
        if (e.status === 'approved') {
          this.totalApprovedGiftcard = this.totalApprovedGiftcard + e.amount
        }
      })
      this.loading = false
    },
    async transferToUser() {
      this.isLoadingTransferFunds = true

      const req = await transfer.data().transferToAUser({
        amount: this.amountTransfer,
        userUsername: this.user.username
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        // this.transferFunds = false
        this.isLoadingTransferFunds = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Transfer Successful',
        status: true,
        error: false
      })

      this.isLoadingTransferFunds = false
      this.transferFunds = false
      this.amountTransfer = ''
    },
    async deactivateAccount() {
      this.changingAccountStatus = true
      const req = await userApi.users().deactivateAccount({
        userId: this.userId,
        suspensionReason: this.deactivitate.suspensionReason
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.changingAccountStatus = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Account Deactivated/Suspended Successfully',
        status: true,
        error: false
      })

      this.deactivateReason = false
      this.deactivitate.suspensionReason = ''
      this.user.activeStatus = 'deactivated'
      this.changingAccountStatus = false

      this.getUserDetails()
    },
    async activateAccount() {
      this.changingAccountStatus = true
      const req = await userApi.users().activateAccount({
        userId: this.userId
      })

      if (req.error) {
        this.$store.dispatch('alert', {
          message:
            req.errorMessage.message ||
            `${req.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.changingAccountStatus = false
        return
      }

      this.$store.dispatch('alert', {
        message: 'Account Activated',
        status: true,
        error: false
      })
      this.user.activeStatus = 'active'
      this.changingAccountStatus = false

      this.getUserDetails()
    },
    async getRanks() {
      this.loadingRanks = true
      const res = await rank.ranksApi().getRanks({
        limit: 0,
        orderBy: 'level',
        order: 'asc'
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        return
      }
      this.ranks = res.data.data.data
      this.loadingRanks = false
    }
  },
  computed: {
    ...mapState({
      admin: (state) => state.admin.admin
    }),
    // `activeStatus` ("active" | "deactivated") is the account state - `status`
    // is a different flag and was showing the wrong thing here.
    isUserActive() {
      return this.user && this.user.activeStatus === 'active'
    },
    arrangeUserData() {
      if (this.user === {}) return
      return {
        ...this.user,
        purchase: { total: 0.0 },
        sales: { total: 0.0 },
        giftcard: { total: 0.0 },
        info: [
          {
            title: 'Full Name',
            text: `${this.user.fname} ${this.user.lname}`
          },
          {
            title: 'Username',
            text: `${this.user.username}`
          },
          {
            title: 'Email',
            text: `${this.user.email}`
          },
          {
            title: 'Address',
            text: `${this.user.address || ''}`
          },
          {
            title: 'Date of Birth',
            text: `${this.user.dob || ''}`
          },
          {
            title: 'Phone',
            text: `${this.user.phone || ''}`
          },
          {
            title: 'Rank',
            text: `${
              this.ranks.find((r) => r.level === this.user.rankLevel)?.title ||
              ''
            }`
          },

          {
            title: 'Suspension Reason',
            text: this.user.suspensionReason || 'No Suspension reason'
          }
        ],
        moreInfo: [
          // {
          //   title: 'Last Login',
          //   text: '16 minutes ago'
          // },
          // {
          //   title: 'Last Login IP',
          //   text: '197.218.8.12'
          // },
          // {
          //   title: 'Last Login Location',
          //   text: 'Africa, Nigeria, Lagos'
          // }
        ]
      }
    },
    userCurrency() {
      return getCurrencyCode(this.user.country)
    },
    statusInfo: () => (hasTransactionHistory) => {
      if (hasTransactionHistory) {
        return {
          color: 'success',
          text: 'Active '
        }
      } else {
        return {
          color: 'error',
          text: 'Inactive'
        }
      }
    },
    filteredReferrals() {
      if (this.referralStatus === 'all') {
        return this.referrals
      }
      if (this.referralStatus === 'active-referrals') {
        return this.referrals.filter((r) => r.hasTransactionHistory)
      }
      if (this.referralStatus === 'inactive-referrals') {
        return this.referrals.filter((r) => !r.hasTransactionHistory)
      }
      return this.referrals
    }
  }
}
</script>

<style></style>
